<template>
  <b-col
    md="4"
    class="d-flex mb-3"
  >
    <b-card class="w-100 h-100 product-card">
      <b-row class="align-items-start">
        <b-col
          cols="4"
          class="text-center"
        >
          <img
            :src="activeImageUrl"
            alt="Product"
            class="product-image"
            @click="openPreview(activeImageUrl)"
          >
        </b-col>

        <b-col cols="8">
          <h5 class="mb-1">
            {{ item.name }}
          </h5>
          <p class="mb-1">
            <strong>Marka:</strong> {{ item.product.brand.name }}
          </p>
          <p class="mb-1">
            <strong>Kategori:</strong> {{ item.product.category.name }}
          </p>
        </b-col>
      </b-row>
      <b-row v-if="mediaUrls.length > 1">
        <b-col cols="12">
          <div class="thumb-list mt-50">
            <img
              v-for="(imageUrl, index) in mediaUrls"
              :key="imageUrl"
              :src="imageUrl"
              alt="Product Thumbnail"
              class="thumb-image"
              :class="{ 'is-active': index === activeImageIndex }"
              @click="activeImageIndex = index"
            >
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col md="12">
          <div class="mb-0">
            <strong>Barkodlar:</strong>
            <div
              v-if="variants.length"
              class="variant-list mt-50"
            >
              <div
                v-for="variant in variants"
                :key="variant.id || variant.barcode"
              >

                <b-row class="variant-item">
                  <b-col cols="12">
                    <span class="variant-barcode">
                      Barkod: {{ variant.barcode || '-' }}
                      <feather-icon
                        v-if="variant.barcode"
                        icon="CopyIcon"
                        size="14"
                        class="variant-copy"
                        @click="doCopy(variant.barcode)"
                      />
                    </span> 
                    &nbsp;&nbsp;
                    <a
                      v-if="variant.url"
                      :href="variant.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="variant-link"
                      title="Barkod Linki"
                    >
                      <feather-icon
                        icon="LinkIcon"
                        size="14"
                      />
                    </a>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <product-sub-products
                      :product="tyProduct(variant)"
                    />
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </b-col>

</template>

<script>
import copyMixins from '@/mixins/copyMixins'
import ProductSubProducts from '@/views/v2/trendyol/product/ProductSubProducts.vue'

export default {
  name: 'Product',
  components: {
    ProductSubProducts,
  },
  mixins: [copyMixins],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeImageIndex: 0,
    }
  },
  computed: {
    mediaUrls() {
      if (!Array.isArray(this.item.medias)) {
        return []
      }

      return this.item.medias
        .map(media => this.formatImageUrl(media?.url))
        .filter(Boolean)
    },
    activeImageUrl() {
      return this.mediaUrls[this.activeImageIndex] || this.mediaUrls[0] || ''
    },
    variants() {
      return Array.isArray(this.item.variants) ? this.item.variants : []
    },
    getImageUrl() {
      if (!this.item.medias || !this.item.medias[0] || !this.item.medias[0].url) {
        return ''
      }

      return this.formatImageUrl(this.item.medias[0].url)
    },
  },
  methods: {
    tyProduct(variant) {
      return {
        id: null,
        product_name: this.item.name,
        merchant_sku: variant?.barcode,
        images: [],
      }
    },
    openPreview(imageUrl) {
      this.$emit('open-preview', imageUrl)
    },
    formatImageUrl(url) {
      if (!url) {
        return ''
      }

      const normalizedUrl = url.replace(/\/(\d+)\.jpg$/, '/$1_org_zoom.jpg')
      return `https://cdn.dsmcdn.com/${normalizedUrl}`
    },
  },
}
</script>

<style scoped>
.product-image {
  width: 100%;
  max-width: 220px;
  height: auto;
  object-fit: contain;
  cursor: zoom-in;
}

.thumb-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
}

.thumb-image {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border: 1px solid #d8d6de;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.7;
}

.thumb-image.is-active {
  border-color: #7367f0;
  opacity: 1;
}

.variant-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.variant-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.variant-barcode {
  font-size: 0.9rem;
}

.variant-link {
  display: inline-flex;
  color: inherit;
}

.variant-copy {
  cursor: pointer;
  margin-left: 6px;
}

.product-card {
  display: flex;
  flex-direction: column;
}
</style>
